import React from 'react';

import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const DoubleArrowUpActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();

  return (
    <BaseActionButton {...props}>
      <KeyboardDoubleArrowUpIcon className={classes.icon} />
    </BaseActionButton>
  );
};

export default DoubleArrowUpActionButton;
